import { helper } from '@ember/component/helper';
import { parseISO } from 'date-fns';

export const parseISODate = ([dateString]) => {
  return parseISO(dateString);
};

export default helper(parseISODate);
